module.exports = __webpack_public_path__ + "img/print.b95865c3.svg";